import {createStore, applyMiddleware} from 'redux'
import createSagaMiddleware from 'redux-saga'
// import logger from 'redux-logger'
import {persistStore, persistReducer, createTransform} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import reducers from './reducers'
import sagas from './saga'

const sagaMiddleware = createSagaMiddleware({
  onError(error){
    console.log('saga error', error);
  }
});


const transformLoading = createTransform((inboundState, key) => {
  if ('list' in inboundState) {
    return {
      ...inboundState,
      refreshing: false,
      loadingMore: false,
      loading: false,
      deleting: {},
    }
  }
  return inboundState;

}, (outboundState, key) => {
  if ('list' in outboundState){
    return {
      ...outboundState,
      refreshing: false,
      loadingMore: false,
      loading: false,
      deleting: {},
    }
  }

  return {
    ...outboundState,
  }
}, {
  blacklist: [],
});

// WHITELIST
const persistConfig = {
  timeout: 0,
  key: 'root_state',
  storage: storage,
  transforms: [
    transformLoading
  ],
  // whitelist: [],
  whitelist: [
    'events', 'updatedLives', 'newLives', 'stars', 'me', 'updatedFeeds', 'headlineLives', 'reactions',
    'indexRecords', 'dailyHotSearches', 'featuredRecords', 'indexBundle',
  ]
};

const persistedReducer = persistReducer(persistConfig, reducers);

const store = createStore(
    // reducers,
    persistedReducer,
    applyMiddleware(sagaMiddleware),
    // applyMiddleware(logger, sagaMiddleware),
)

const restartSagas = error => {
  console.error(error, '[ERROR] SAGA RUN:', error)
  sagaMiddleware.run(sagas).done.catch(restartSagas)
}

// sagaMiddleware.run(sagas).done.catch(restartSagas);
sagaMiddleware.run(sagas);

export default store;

